import * as React from 'react';
import { getPrettyFloat } from '@cian/frontend-reviews-components';
import { UIHeading4, Avatar, Label, UIText1 } from '@cian/ui-kit';

import { IconToggleStarOn16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';
import { trackTransferToDeveloperCard } from '../../containers/Builder/tracking';
import { IBuilderReviewStats } from '../../types/newbuilding/builder';

export interface IBuilderProps {
  logoUrl: string;
  name: string;
  yearOfFoundation?: number | null;
  done: React.ReactNode;
  inProgress: React.ReactNode;
  offersForSale: React.ReactNode;
  developerCard: React.ReactNode;
  url?: string;
  onBuilderLinkClick(): void;
  reviewStats?: IBuilderReviewStats | null;
  isReliable: boolean;
  contacts: React.ReactNode;
}

export function Builder({
  logoUrl,
  name,
  yearOfFoundation,
  done,
  inProgress,
  offersForSale,
  url,
  developerCard,
  reviewStats,
  isReliable,
  contacts,
}: IBuilderProps) {
  const rate = React.useMemo(() => {
    return reviewStats?.totalRate ? getPrettyFloat(reviewStats?.totalRate) : '';
  }, [reviewStats]);

  const isLowRate = reviewStats ? reviewStats.totalRate < 4 : false;

  return (
    <div className={styles['container']} id="developer" data-testid="BuilderComponent">
      <div className={styles['builder']}>
        {logoUrl && (
          <a
            className={styles['logo-link']}
            href={url}
            target="_blank"
            rel="noreferrer"
            onClick={trackTransferToDeveloperCard}
          >
            <Avatar size={80} src={logoUrl} type="builder" data-testid="BuilderLogo" hideBorder />
          </a>
        )}

        <div className={styles['description']}>
          <UIHeading4 color="text-primary-default" data-testid="BuilderTitle">
            Застройщик
          </UIHeading4>

          <div className={styles['builder-name-section']}>
            <a
              className={styles['name-link']}
              href={url}
              target="_blank"
              rel="noreferrer"
              onClick={trackTransferToDeveloperCard}
            >
              <h2 className={styles['name']} data-testid="BuilderName">
                {name}
              </h2>
            </a>
            <div className={styles['labels']}>
              {rate && (
                <Label
                  icon={<IconToggleStarOn16 color="current_color" />}
                  color={isLowRate ? 'text-secondary-default' : 'decorative-orange'}
                  background="surface-inverted-default"
                  borderColor="accent-main-secondary"
                  borderWidth={1}
                  borderStyle="solid"
                >
                  {rate}
                </Label>
              )}
              {isReliable && (
                <div className={reviewStats ? styles['label--overlap'] : undefined}>
                  <Label
                    color="text-main-default"
                    background="surface-inverted-default"
                    borderColor="accent-main-secondary"
                    borderWidth={1}
                    borderStyle="solid"
                  >
                    Надежный
                  </Label>
                </div>
              )}
            </div>
          </div>

          <div className={styles['stats']}>
            {yearOfFoundation && <UIText1>Работает с {yearOfFoundation} года</UIText1>}
            {done}
            {inProgress}
            {offersForSale}
            {developerCard}
          </div>
        </div>
      </div>
      <div className={styles['contacts']}>{contacts}</div>
    </div>
  );
}
